export default __webpack_public_path__ + "static/media/IRI.f6980301.svg";